import { FC } from 'react';
import { RiskAnalysisChart } from '../../../common/risk-analysis-chart/risk-analysis-chart';
import { GetRiskAnalysisByCancerTypeResponse } from '@/repositories/risk.repository';
import { Box, Text } from '@cmpsr/components';

interface SingleCancerGraphProps {
  currentRiskColor: string;
  riskData: GetRiskAnalysisByCancerTypeResponse['risks'];
  cancerName: string;
}

const SingleCancerGraph: FC<SingleCancerGraphProps> = ({ currentRiskColor, riskData, cancerName }) => {
  return (
    <Box bgColor="#F0F5F6" borderRadius="radii-3" py="4" px="10px">
      <Text textTransform="uppercase" variant="text-body-regular" p="2">
        Your {cancerName} risk by age
      </Text>
      <RiskAnalysisChart currentRiskColor={currentRiskColor} data={riskData} variant="light" />
    </Box>
  );
};

export default SingleCancerGraph;
